import { useEffect, useRef } from 'react';
import { PHONE_1 } from '../../../components/feature/TopBar';

const WA_LINK = `https://wa.me/90${PHONE_1}?text=${encodeURIComponent('Merhaba, kampanya fiyatları hakkında bilgi almak istiyorum. Randevu almak istiyorum.\nAd Soyad:\nTelefon:\nAdres:\nTarih:\nSaat:')}`;

const priceItems = [
  { label: 'Mindersiz Koltuk Takımı', price: '999 TL', highlight: true },
  { label: 'Köşe Koltuk (minder, puf, berjer hariç)', price: '999 TL', highlight: true },
  { label: 'Minder / Yastık (adet)', price: '50 TL', highlight: false },
  { label: 'İki Kişilik Yatak', price: '700 TL', highlight: false },
  { label: 'Tek Kişilik Yatak', price: '600 TL', highlight: false },
  { label: 'Sandalye (adet)', price: '100 TL', highlight: false },
  { label: 'Puf', price: '150 TL', highlight: false },
  { label: 'Ekstra Berjer', price: '250 TL', highlight: false },
  { label: "Ekstra 3'lü Koltuk", price: '350 TL', highlight: false },
];

export default function PricingSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0');
      },
      { threshold: 0.05 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const handleAppointment = () => {
    const el = document.querySelector('#appointment');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="pricing" className="w-full bg-[#1a1a1a] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Header */}
          <div className="text-center mb-14">
            <span className="inline-flex items-center gap-1.5 bg-emerald-500 text-white text-xs font-bold px-4 py-1.5 rounded-full mb-5 uppercase tracking-widest">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-price-tag-3-fill" />
              </span>
              Fırsat Fiyatları
            </span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Kampanya Fiyatlarımız
            </h2>
            <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto">
              Piyasanın altında fiyatlarla profesyonel temizlik hizmeti
            </p>
          </div>

          {/* Top Row: Hero Card + Petek Card */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Hero Pricing Card */}
            <div className="relative bg-emerald-500 rounded-3xl p-8 md:p-10 overflow-hidden flex flex-col justify-between">
              {/* Decorative circles */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full" />
              <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-white/10 rounded-full" />

              <div className="relative z-10">
                <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">
                  En Popüler
                </span>
                <h3 className="text-white font-extrabold text-2xl md:text-3xl mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Mindersiz Koltuk Takımı
                </h3>
                <p className="text-emerald-100 text-sm mb-6">
                  Tam takım profesyonel koltuk yıkama
                </p>
              </div>

              <div className="relative z-10 flex items-end justify-between flex-wrap gap-4">
                <div>
                  <span className="text-white/60 text-sm line-through mr-2">1.499 TL</span>
                  <p className="text-white font-extrabold text-6xl md:text-7xl leading-none" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    999
                    <span className="text-2xl ml-1 font-bold">TL</span>
                  </p>
                </div>
                <button
                  onClick={handleAppointment}
                  className="bg-white hover:bg-gray-100 text-emerald-600 font-bold text-sm px-6 py-3 rounded-xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Randevu Al
                </button>
              </div>
            </div>

            {/* Petek Card */}
            <div className="relative bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10 overflow-hidden flex flex-col justify-between hover:border-emerald-500/40 transition-colors">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-emerald-500/5 rounded-full" />

              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/10 rounded-2xl mb-5">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-fire-line text-emerald-400 text-2xl" />
                  </span>
                </div>
                <h3 className="text-white font-extrabold text-2xl md:text-3xl mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Petek Temizliği
                </h3>
                <p className="text-gray-400 text-sm mb-6 flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-emerald-400" />
                  </span>
                  Kombi altı filtre temizliği dahil
                </p>
              </div>

              <div className="relative z-10 flex items-end justify-between flex-wrap gap-4">
                <div>
                  <span className="text-gray-500 text-sm line-through mr-2">1.499 TL</span>
                  <p className="text-white font-extrabold text-6xl md:text-7xl leading-none" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    999
                    <span className="text-2xl ml-1 font-bold text-emerald-400">TL</span>
                  </p>
                </div>
                <button
                  onClick={handleAppointment}
                  className="bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-sm px-6 py-3 rounded-xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Randevu Al
                </button>
              </div>
            </div>
          </div>

          {/* Price List Table */}
          <div className="bg-white/5 border border-white/10 rounded-3xl overflow-hidden mb-8">
            <div className="px-6 py-4 border-b border-white/10 flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-list-check-2 text-emerald-400" />
              </span>
              <span className="text-white font-bold text-base">Tüm Hizmet Fiyatları</span>
            </div>
            <div className="divide-y divide-white/5">
              {priceItems.map((item) => (
                <div
                  key={item.label}
                  className={`flex items-center justify-between px-6 py-4 transition-colors hover:bg-white/5 ${item.highlight ? 'bg-emerald-500/10' : ''}`}
                >
                  <div className="flex items-center gap-3">
                    {item.highlight && (
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-star-fill text-emerald-400 text-xs" />
                      </span>
                    )}
                    {!item.highlight && (
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-line text-gray-500 text-xs" />
                      </span>
                    )}
                    <span className={`text-sm ${item.highlight ? 'text-white font-semibold' : 'text-gray-300'}`}>
                      {item.label}
                    </span>
                  </div>
                  <span className={`font-extrabold text-base whitespace-nowrap ${item.highlight ? 'text-emerald-400' : 'text-white'}`}>
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Trust Note + Psychological Trigger */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
            {/* Trust */}
            <div className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-2xl px-5 py-5">
              <span className="w-9 h-9 flex items-center justify-center bg-emerald-500/10 rounded-xl flex-shrink-0">
                <i className="ri-shield-check-line text-emerald-400 text-xl" />
              </span>
              <div>
                <p className="text-white font-semibold text-sm mb-1">Güvenilir Hizmet</p>
                <p className="text-gray-400 text-xs leading-relaxed">
                  18 yıllık tecrübemizle, doğru ekipman ve profesyonel yöntemlerle hizmet veriyoruz.
                </p>
              </div>
            </div>

            {/* Psychological Trigger */}
            <div className="flex items-start gap-3 bg-red-500/10 border border-red-500/20 rounded-2xl px-5 py-5">
              <span className="w-9 h-9 flex items-center justify-center bg-red-500/10 rounded-xl flex-shrink-0">
                <i className="ri-error-warning-line text-red-400 text-xl" />
              </span>
              <div>
                <p className="text-white font-semibold text-sm mb-1">Dikkat!</p>
                <p className="text-red-300 text-xs leading-relaxed">
                  Yanlış temizlik uygulamaları daha büyük maliyetlere yol açabilir.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={handleAppointment}
              className="w-full sm:w-auto flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-base px-10 py-4 rounded-xl transition-all hover:scale-105 shadow-lg shadow-emerald-500/20 whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-check-line" />
              </span>
              Hemen Randevu Al
            </button>
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-white/20 hover:border-emerald-500 text-white font-bold text-base px-10 py-4 rounded-xl transition-all hover:bg-emerald-500/10 whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line" />
              </span>
              WhatsApp ile Yaz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
